import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  putUserDataFailure,
  putUserDataSuccess,
} from "../slices/features/user";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* putUserSaga(action: any) {
  const { payload } = action;
  const { id, data } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.putUser,
      baseUrl,
      id,
      data
    );

    yield put(putUserDataSuccess({ ...response }));

    payload?.cbSuccess && payload.cbSuccess({ ...response });
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(putUserDataFailure({ statusCode, statusText }));
  }
}

export function* watchPutUser() {
  yield takeLatest(RequestTypes.PUT_USER_REQUEST, putUserSaga);
}
